const ts = {
  GRID_HEADER_NAME: {
    description: 'Family Name in Grid Header',
    primaryValue: 'Name',
    stringKey: 'GRID_HEADER_NAME',
  },
  ACCESS_TEXT: {
    description: 'Access in Grid Header',
    primaryValue: 'Access',
    stringKey: 'ACCESS_TEXT',
  },
  GRID_HEADER_STATUS: {
    description: 'Status in Grid Header',
    primaryValue: 'Status',
    stringKey: 'GRID_HEADER_STATUS',
  },
  PASS_STATUS_INACTIVE: {
    description: 'Inactive Status',
    primaryValue: 'Inactive',
    stringKey: 'PASS_STATUS_INACTIVE',
  },
  PASS_STATUS_REGISTERED: {
    description: 'Registered Status',
    primaryValue: 'Registered',
    stringKey: 'PASS_STATUS_REGISTERED',
  },
  PASS_STATUS_USED: {
    description: 'Used Status',
    primaryValue: 'Used',
    stringKey: 'PASS_STATUS_USED',
  },
  PASS_STATUS_SUSPENDED: {
    description: 'Suspended Status',
    primaryValue: 'Suspended',
    stringKey: 'PASS_STATUS_SUSPENDED',
  },
  PASS_STATUS_PENDING: {
    description: 'Pending Status',
    primaryValue: 'Pending',
    stringKey: 'PASS_STATUS_PENDING',
  },
  PASS_STATUS_EXPIRED: {
    description: 'Expired Status',
    primaryValue: 'Expired',
    stringKey: 'PASS_STATUS_EXPIRED',
  },
  PASS_STATUS_DENIED: {
    description: 'Denied Status',
    primaryValue: 'Denied',
    stringKey: 'PASS_STATUS_DENIED',
  },
  PASS_STATUS_DECLINED: {
    description: 'Declined Status',
    primaryValue: 'Declined',
    stringKey: 'PASS_STATUS_DECLINED',
  },
  PASS_STATUS_CHECKED_IN: {
    description: 'Checked In Status',
    primaryValue: 'Checked In',
    stringKey: 'PASS_STATUS_CHECKED_IN',
  },
  PASS_STATUS_CANCELED: {
    description: 'Canceled Status',
    primaryValue: 'Canceled',
    stringKey: 'PASS_STATUS_CANCELED',
  },
  MYACCESS_MANAGESTORE_TEXT: {
    description: 'Manage Store Text',
    primaryValue: 'Manage Your Store & Online Account Benefits',
    stringKey: 'MYACCESS_MANAGESTORE_TEXT',
  },
  SELECT_APPLY_TEXT: {
    description: 'Select Apply Text',
    primaryValue: '(Select all that apply)',
    stringKey: 'SELECT_APPLY_TEXT',
  },
  REQUESTEDACCESS_TEXT: {
    description: 'Requested Access Text',
    primaryValue: 'Requested Access',
    stringKey: 'REQUESTEDACCESS_TEXT',
  },
  GRID_HEADER_RELATIONSHIP: {
    description: 'Relationship Header',
    primaryValue: 'Relationship',
    stringKey: 'GRID_HEADER_RELATIONSHIP',
  },
  GRID_HEADER_ACTIONS: {
    description: 'Actions Header',
    primaryValue: 'Actions',
    stringKey: 'GRID_HEADER_ACTIONS',
  },
  INFOBOX_FAMILY_MEMBERS: {
    description: 'Infobox Family Members',
    primaryValue: 'Family Members',
    stringKey: 'INFOBOX_FAMILY_MEMBERS',
  },
  INFOBOX_ADD_FAMILY: {
    description: 'Infobox Add Family',
    primaryValue: 'Add Family',
    stringKey: 'INFOBOX_ADD_FAMILY',
  },
  FAMILY_ACTIVE_PAGE_NAME: {
    description: 'Family Active Page Name',
    primaryValue: 'My Family',
    stringKey: 'FAMILY_ACTIVE_PAGE_NAME',
  },
  FAMILY_ADDED: {
    description: 'Family Added',
    primaryValue: 'Family Added',
    stringKey: 'FAMILY_ADDED',
  },
  FAMILY_EMAIL_MAIN_CONTENT: {
    description: 'Family Email Main Content',
    primaryValue:
      "{{Family Member}}, you've been hooked up with inside access from {{Employee}} to shop the best of Nike at employee pricing.\n\nYou will be able to enjoy Nike employee pricing for as long as {{Employee}} remains an employee.\n\nWith this pass, receive access to the Nike Company Store.",
    stringKey: 'FAMILY_EMAIL_MAIN_CONTENT',
  },
  FAMILY_EMAIL_STEP_1_CONTENT: {
    description: 'Family Email Step 1 Content',
    primaryValue: 'Keep this email to scan your barcode when you check out at the register.',
    stringKey: 'FAMILY_EMAIL_STEP_1_CONTENT',
  },
  FAMILY_EMAIL_SUBJECT: {
    description: 'Family Email Subject',
    primaryValue: 'Your Nike Family Shopping Pass',
    stringKey: 'FAMILY_EMAIL_SUBJECT',
  },
  FAMILY_EMPTY_TEXT: {
    description: 'Family Empty Text',
    primaryValue:
      'No family members match the selected drop-down filters. Try adjusting the filters for more results or click on \\Add Family Member\\',
    stringKey: 'FAMILY_EMPTY_TEXT',
  },
  FAMILY_ERROR_ADDING_RECORD: {
    description: 'Family Error Adding Record',
    primaryValue: 'Error adding record',
    stringKey: 'FAMILY_ERROR_ADDING_RECORD',
  },
  FAMILY_ERROR_DUPLICATE: {
    description: 'Family Error Duplicate',
    primaryValue: 'Error adding record: Duplicate entry',
    stringKey: 'FAMILY_ERROR_DUPLICATE',
  },
  FAMILY_ERROR_UPDATING_RECORD: {
    description: 'Family Error Updating Record',
    primaryValue: 'Error updating record',
    stringKey: 'FAMILY_ERROR_UPDATING_RECORD',
  },
  FAMILY_MODAL_ADD_FAMILY: {
    description: 'Family Modal Add Family',
    primaryValue: 'Add Family Member',
    stringKey: 'FAMILY_MODAL_ADD_FAMILY',
  },
  FAMILY_MODAL_EDIT_FAMILY: {
    description: 'Family Modal Edit Family',
    primaryValue: 'Edit Family Member',
    stringKey: 'FAMILY_MODAL_EDIT_FAMILY',
  },
  FAMILY_MODAL_FAMILY_INFO_HEADING: {
    description: 'Family Modal Family Info Heading',
    primaryValue: 'Family Member Info',
    stringKey: 'FAMILY_MODAL_FAMILY_INFO_HEADING',
  },
  FAMILY_MODAL_MANAGER_HEADING: {
    description: 'Family Modal Manager Heading',
    primaryValue: 'Approving Manager',
    stringKey: 'FAMILY_MODAL_MANAGER_HEADING',
  },
  FAMILY_MODAL_NO_FAMILY_ADDED_TEXT: {
    description: 'Family Modal No Family Added Text',
    primaryValue: 'No Family added ...',
    stringKey: 'FAMILY_MODAL_NO_FAMILY_ADDED_TEXT',
  },
  FAMILY_MODAL_RECEPTION_WARNING_MESSAGE: {
    description: 'Family Modal Reception Warning Message',
    primaryValue: 'Family members may not be added for ETW or Retired employees',
    stringKey: 'FAMILY_MODAL_RECEPTION_WARNING_MESSAGE',
  },
  FAMILY_MODAL_REGISTER: {
    description: 'Family Modal Register',
    primaryValue: 'Register',
    stringKey: 'FAMILY_MODAL_REGISTER',
  },
  FAMILY_MODAL_REMOVE_FAMILY: {
    description: 'Family Modal Remove Family',
    primaryValue: 'Remove Family Member',
    stringKey: 'FAMILY_MODAL_REMOVE_FAMILY',
  },
  FAMILY_MODAL_UPDATE: {
    description: 'Family Modal Update',
    primaryValue: 'Update',
    stringKey: 'FAMILY_MODAL_UPDATE',
  },
  FAMILY_MULTIPLE_ADDED: {
    description: 'Family Multiple Added',
    primaryValue: 'Multiple Family Members Added',
    stringKey: 'FAMILY_MULTIPLE_ADDED',
  },
  FAMILY_MULTIPLE_UPDATED: {
    description: 'Family Multiple Updated',
    primaryValue: 'Multiple Family Members Updated',
    stringKey: 'FAMILY_MULTIPLE_UPDATED',
  },
  FAMILY_REMOVED: {
    description: 'Family Removed',
    primaryValue: 'Removed',
    stringKey: 'FAMILY_REMOVED',
  },
  FAMILY_SOME_RECORDS_SAVED: {
    description: 'Family Some Records Saved',
    primaryValue: 'Some Records Saved',
    stringKey: 'FAMILY_SOME_RECORDS_SAVED',
  },
  FAMILY_UPDATED: {
    description: 'Family Updated',
    primaryValue: 'Family Updated',
    stringKey: 'FAMILY_UPDATED',
  },
  CANCEL_FAMILY_MODAL_INFORM: {
    description: 'Cancel Family Modal Inform',
    primaryValue: 'Be sure to inform your family member',
    stringKey: 'CANCEL_FAMILY_MODAL_INFORM',
  },
  CANCEL_FAMILY_MODAL_KEEP: {
    description: 'Cancel Family Modal Keep',
    primaryValue: 'Keep',
    stringKey: 'CANCEL_FAMILY_MODAL_KEEP',
  },
  CANCEL_FAMILY_MODAL_REMOVE: {
    description: 'Cancel Family Modal Remove',
    primaryValue: 'Remove',
    stringKey: 'CANCEL_FAMILY_MODAL_REMOVE',
  },
  EMAIL_FAMILY_ALT_MANAGER_TITLE: {
    description: 'Email Family Alt Manager Title',
    primaryValue: 'Approve family changes for {0}',
    stringKey: 'EMAIL_FAMILY_ALT_MANAGER_TITLE',
  },
  EMAIL_FAMILY_APPROVAL_TITLE: {
    description: 'Email Family Approval Title',
    primaryValue: 'Family list approval',
    stringKey: 'EMAIL_FAMILY_APPROVAL_TITLE',
  },
  EMAIL_FAMILY_LIST: {
    description: 'Email Family List',
    primaryValue: 'family list',
    stringKey: 'EMAIL_FAMILY_LIST',
  },
  RELATIONSHIP_BROTHER: {
    description: 'Brother Relationship',
    primaryValue: 'Brother',
    stringKey: 'RELATIONSHIP_BROTHER',
  },
  RELATIONSHIP_BROTHER_IN_LAW: {
    description: 'Brother-in-law Relationship',
    primaryValue: 'Brother-in-law',
    stringKey: 'RELATIONSHIP_BROTHER_IN_LAW',
  },
  RELATIONSHIP_CHILD: {
    description: 'Child Relationship',
    primaryValue: 'Child',
    stringKey: 'RELATIONSHIP_CHILD',
  },
  RELATIONSHIP_DAUGHTER: {
    description: 'Daughter Relationship',
    primaryValue: 'Daughter',
    stringKey: 'RELATIONSHIP_DAUGHTER',
  },
  RELATIONSHIP_DAUGHTER_IN_LAW: {
    description: 'Daughter-in-law Relationship',
    primaryValue: 'Daughter-in-law',
    stringKey: 'RELATIONSHIP_DAUGHTER_IN_LAW',
  },
  RELATIONSHIP_FATHER: {
    description: 'Father Relationship',
    primaryValue: 'Father',
    stringKey: 'RELATIONSHIP_FATHER',
  },
  RELATIONSHIP_FATHER_IN_LAW: {
    description: 'Father-in-law Relationship',
    primaryValue: 'Father-in-law',
    stringKey: 'RELATIONSHIP_FATHER_IN_LAW',
  },
  RELATIONSHIP_GRANDCHILD: {
    description: 'Grandchild Relationship',
    primaryValue: 'Grandchild',
    stringKey: 'RELATIONSHIP_GRANDCHILD',
  },
  RELATIONSHIP_GRANDFATHER: {
    description: 'Grandfather Relationship',
    primaryValue: 'Grandfather',
    stringKey: 'RELATIONSHIP_GRANDFATHER',
  },
  RELATIONSHIP_GRANDFATHER_IN_LAW: {
    description: 'Grandfather-in-law Relationship',
    primaryValue: 'Grandfather-in-law',
    stringKey: 'RELATIONSHIP_GRANDFATHER_IN_LAW',
  },
  RELATIONSHIP_GRANDMOTHER: {
    description: 'Grandmother Relationship',
    primaryValue: 'Grandmother',
    stringKey: 'RELATIONSHIP_GRANDMOTHER',
  },
  RELATIONSHIP_GRANDMOTHER_IN_LAW: {
    description: 'Grandmother-in-law Relationship',
    primaryValue: 'Grandmother-in-law',
    stringKey: 'RELATIONSHIP_GRANDMOTHER_IN_LAW',
  },
  RELATIONSHIP_GRAND_DAUGHTER: {
    description: 'Granddaughter Relationship',
    primaryValue: 'Granddaughter',
    stringKey: 'RELATIONSHIP_GRAND_DAUGHTER',
  },
  RELATIONSHIP_GRAND_SON: {
    description: 'Grandson Relationship',
    primaryValue: 'Grandson',
    stringKey: 'RELATIONSHIP_GRAND_SON',
  },
  RELATIONSHIP_MOTHER: {
    description: 'Mother Relationship',
    primaryValue: 'Mother',
    stringKey: 'RELATIONSHIP_MOTHER',
  },
  RELATIONSHIP_MOTHER_IN_LAW: {
    description: 'Mother-in-law Relationship',
    primaryValue: 'Mother-in-law',
    stringKey: 'RELATIONSHIP_MOTHER_IN_LAW',
  },
  RELATIONSHIP_SISTER: {
    description: 'Sister Relationship',
    primaryValue: 'Sister',
    stringKey: 'RELATIONSHIP_SISTER',
  },
  RELATIONSHIP_SISTER_IN_LAW: {
    description: 'Sister-in-law Relationship',
    primaryValue: 'Sister-in-law',
    stringKey: 'RELATIONSHIP_SISTER_IN_LAW',
  },
  RELATIONSHIP_SON: {
    description: 'Son Relationship',
    primaryValue: 'Son',
    stringKey: 'RELATIONSHIP_SON',
  },
  RELATIONSHIP_SON_IN_LAW: {
    description: 'Son-in-law Relationship',
    primaryValue: 'Son-in-law',
    stringKey: 'RELATIONSHIP_SON_IN_LAW',
  },
  RELATIONSHIP_SPOUSE_PARTNER: {
    description: 'Spouse/Partner Relationship',
    primaryValue: 'Spouse/Partner',
    stringKey: 'RELATIONSHIP_SPOUSE_PARTNER',
  },
  RELATIONSHIP_STEP_BROTHER: {
    description: 'Stepbrother Relationship',
    primaryValue: 'Stepbrother',
    stringKey: 'RELATIONSHIP_STEP_BROTHER',
  },
  RELATIONSHIP_STEP_DAUGHTER: {
    description: 'Stepdaughter Relationship',
    primaryValue: 'Stepdaughter',
    stringKey: 'RELATIONSHIP_STEP_DAUGHTER',
  },
  RELATIONSHIP_STEP_FATHER: {
    description: 'Stepfather Relationship',
    primaryValue: 'Stepfather',
    stringKey: 'RELATIONSHIP_STEP_FATHER',
  },
  RELATIONSHIP_STEP_FATHER_IN_LAW: {
    description: 'Stepfather-in-law Relationship',
    primaryValue: 'Stepfather-in-law',
    stringKey: 'RELATIONSHIP_STEP_FATHER_IN_LAW',
  },
  RELATIONSHIP_STEP_MOTHER: {
    description: 'Stepmother Relationship',
    primaryValue: 'Stepmother',
    stringKey: 'RELATIONSHIP_STEP_MOTHER',
  },
  RELATIONSHIP_STEP_MOTHER_IN_LAW: {
    description: 'Stepmother-in-law Relationship',
    primaryValue: 'Stepmother-in-law',
    stringKey: 'RELATIONSHIP_STEP_MOTHER_IN_LAW',
  },
  RELATIONSHIP_STEP_SISTER: {
    description: 'Stepsister Relationship',
    primaryValue: 'Stepsister',
    stringKey: 'RELATIONSHIP_STEP_SISTER',
  },
  RELATIONSHIP_STEP_SON: {
    description: 'Stepson Relationship',
    primaryValue: 'Stepson',
    stringKey: 'RELATIONSHIP_STEP_SON',
  },
  RELATIONSHIP_PARENT: {
    description: 'Parent Relationship',
    primaryValue: 'Parent',
    stringKey: 'RELATIONSHIP_PARENT',
  },
  RELATIONSHIP_GRANDPARENT: {
    description: 'Grandparent Relationship',
    primaryValue: 'Grandparent',
    stringKey: 'RELATIONSHIP_GRANDPARENT',
  },
  RELATIONSHIP_SIBLING: {
    description: 'Sibling Relationship',
    primaryValue: 'Sibling',
    stringKey: 'RELATIONSHIP_SIBLING',
  },
  RELATIONSHIP_IN_LAW: {
    description: 'In-law Relationship',
    primaryValue: 'In-law',
    stringKey: 'RELATIONSHIP_IN_LAW',
  },
  DDL_ALL: {
    description: 'All',
    primaryValue: 'All',
    stringKey: 'DDL_ALL',
  },
  DDL_ACTIVE: {
    description: 'Active',
    primaryValue: 'Active',
    stringKey: 'DDL_ACTIVE',
  },
  DDL_INACTIVE: {
    description: 'Inactive',
    primaryValue: 'Inactive',
    stringKey: 'DDL_INACTIVE',
  },
  SAVING_TEXT: {
    description: 'Saving Text',
    primaryValue: 'Saving',
    stringKey: 'SAVING_TEXT',
  },
  PLACEHOLDER_LAST_NAME: {
    description: 'Last Name',
    primaryValue: 'Last Name',
    stringKey: 'PLACEHOLDER_LAST_NAME',
  },
  PLACEHOLDER_FIRST_NAME: {
    description: 'First Name',
    primaryValue: 'First Name',
    stringKey: 'PLACEHOLDER_FIRST_NAME',
  },
  DDL_RELATIONSHIP_SELECT: {
    description: 'Select Relationship',
    primaryValue: 'Select Relationship',
    stringKey: 'DDL_RELATIONSHIP_SELECT',
  },
  GRID_HEADER_WE_CHAT_ID: {
    description: 'WeChat ID in Grid Header',
    primaryValue: 'WeChat ID',
    stringKey: 'GRID_HEADER_WE_CHAT_ID',
  },
  PLACEHOLDER_WE_CHAT_ID: {
    description: 'WeChat ID',
    primaryValue: 'WeChat ID',
    stringKey: 'PLACEHOLDER_WE_CHAT_ID',
  },
};

export default ts;
